import { routeStoreLenses } from 'root/src/client/logic/route/lenses'

const { pathOrPreviousRoute } = routeStoreLenses

export default pathOrPreviousRoute({})
